// extracted by mini-css-extract-plugin
export var typingIndicator = "_ou-0";